import {gsap} from "gsap";

window.addEventListener("DOMContentLoaded", () => {
    const shapes = ["#square", "#circleLeft", "#circleRight"]

    shapes.forEach(s => {
        const element = document.querySelector(s);
        function rotate(e) {
            const r = Math.random() * 360 - 180;

            gsap.to(e, {
                rotation: "+=" + (r + "deg"),
                ease: "power1.inOut",
                duration: Math.abs(r / 360 * 70),
                onComplete: () => {
                    rotate(e)
                }
            });
        }

        if (element) {

            gsap.to(s, {
                x: () => "+=" + (Math.random() * 200 - 100),
                y: () => "+=" + (Math.random() * 200 - 100),
                scale: () => "+=" + (Math.random() * 0.1 - 0.05),
                ease: "power1.inOut",
                opacity: () => Math.random() * (1 - 0.7) + 0.7,
                duration: () => Math.random() * (4 - 3) + 3,
                repeat: -1,
                yoyo: true,
                repeatRefresh: true,
            });

            rotate(s)
        }
    });
});